module.exports = __webpack_public_path__ + "img/ML.593dcabf.svg";